import { Textarea } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * TextareaFormField provides support for a standard TextArea component to be used in a Form.
 */

export const TextareaFormField = withFormField(Textarea);
